import { connect } from "react-redux";
import React from "react";
import { Grid, WithStyles, withStyles, Typography, Button } from "material-ui";
import moment from "moment";
import { ReduxState, ReduxDispatch } from "../../../../ducks/reducers";
import { IChatMessage, IHandler } from "../../../../util/interfaces";
import { DownloadIcon } from "views/documentation/components/DownloadIcon";
import { getAttachmentById } from "ducks/attachments";
import { AttachmentDto, AttachmentInfoDto } from "util/DTOs/AttachmentDtos";
import { attachmentToBlob } from "util/handleAttachments";
import { getPortaaliAttachmentData, portaaliAttachmentDownloadUrl } from "util/request";
import { downloadAndSaveFile } from "util/platformUtils";

const styles = {
    chatBubble: {
        margin: "30px",
        marginLeft: "20px",
        marginRight: "20px",
        display: "inline-block",
        position: "relative",

        height: "auto",
        backgroundColor: "#f8f8ff",
        border: "2px solid #92c9f0",
        width: "80%",
        borderRadius: "15px",
    },
    triTop: {
        "&:before": {
            content: `" "`,
            position: "absolute",
            width: 0,
            height: 0,
            left: "30px",
            right: "auto",
            top: "-30px",
            bottom: "auto",
            border: "15px solid",
            borderColor: "transparent transparent #92c9f0 transparent",
        },
        "&:after": {
            content: `" "`,
            position: "absolute",
            width: 0,
            height: 0,
            left: "33px",
            right: "auto",
            top: "-24px",
            bottom: "auto",
            border: "12px solid",
            borderColor: "transparent transparent #f8f8ff transparent",
        },
    },
    own: {
        border: "2px solid rgb(169, 169, 169)",
        backgroundColor: "rgb(233, 243, 249)",
        float: "right",
        "&:before": {
            right: "30px",
            left: "auto",
            top: "auto",
            bottom: "-30px",
            border: "15px solid",
            borderColor:
                "rgb(169, 169, 169) transparent transparent  transparent",
        },
        "&:after": {
            right: "33px",
            left: "auto",
            top: "auto",
            bottom: "-24px",
            border: "12px solid",
            borderColor:
                "rgb(233, 243, 249) transparent transparent  transparent",
        },
    },
    talktext: {
        padding: "1em",
        textAlign: "left",
        lineHeight: "1.5em",
        color: "#646363",
        fontSize: "20px",
        whiteSpace: "pre-wrap",
    },
    date: {
        fontWeight: 400,
        color: "#646363",
        position: "relative",
        float: "right",
        padding: "8px",
    },
    bottomContainer: {
        display: "flex",
        justifyContent: "space-around",
    },
    bottomContainerLeft: {
        display: "flex",
        flex: 2,
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "0 8px",
    },
    bottomContainerLeftInner: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    bottomContainerRight: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end",
    },
} as React.CSSProperties;

/**
 * Props provided by redux
 */
interface IChatMessagesProps {
    message: IChatMessage;
}

/**
 * Internal state of this component
 */
interface IChatMessagesState {}

/**
 * Dispatch functions provided by redux
 */
interface IChatMessagesDispatchProps {
    getAttachmentByAttachmentId: (id: number) => Promise<AttachmentDto>;
}

interface IChatMessagesReduxProps {}

/**
 * Combined properties of he component
 */
type IChatMessagesPropsWithStyles = IChatMessagesProps &
    IChatMessagesDispatchProps &
    WithStyles<
        | "chatBubble"
        | "talktext"
        | "date"
        | "triTop"
        | "own"
        | "bottomContainer"
        | "bottomContainerLeft"
        | "bottomContainerLeftInner"
        | "bottomContainerRight"
    >;

const ChatMessage: React.SFC<IChatMessagesPropsWithStyles> = ({
    classes,
    ...props
}: IChatMessagesPropsWithStyles) => {
    const { message, getAttachmentByAttachmentId } = props;

    function createMarkup() {
        return { __html: message.message };
    }

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <div
                    className={`${classes.chatBubble} ${classes.triTop} ${
                        message.own ? classes.own : ""
                    }`}
                >
                    <Typography
                        variant="body1"
                        color="inherit"
                        className={classes.talktext}
                        //dangerouslySetInnerHTML={createMarkup()}
                    >
                        {message.message}
                    </Typography>
                    <div className={classes.bottomContainer}>
                        <div className={classes.bottomContainerLeft}>
                            <div className={classes.bottomContainerLeftInner}>
                                {message.attachments &&
                                    message.attachments.length > 0 &&
                                    message.attachments.map((attachment) => (
                                        <Button
                                            className={
                                                "chat-message-download-button"
                                            }
                                            onClick={() => {
                                                getPortaaliAttachmentData(attachment.id)
                                                    .then((data) => {
                                                        const url = portaaliAttachmentDownloadUrl(data.id);
                                                        return downloadAndSaveFile(url, data.fileName, data.mimeType);
                                                    })
                                                    .then(() => {
                                                        console.log("download success");
                                                    })
                                                    .catch(console.error);
                                            }}
                                        >
                                            <DownloadIcon />
                                            <Typography
                                                className={
                                                    "attachment-filename"
                                                }
                                            >
                                                {attachment.fileName || ""}
                                            </Typography>
                                        </Button>
                                    ))}
                            </div>
                        </div>
                        <div className={classes.bottomContainerRight}>
                            <Typography className={classes.date}>
                                {moment(message.date).format(
                                    "DD.MM.YYYY HH:mm"
                                )}
                            </Typography>
                        </div>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state: ReduxState): IChatMessagesReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IChatMessagesDispatchProps => {
    return {
        getAttachmentByAttachmentId: (id: number) => {
            return dispatch(getAttachmentById(id));
        },
    };
};

export default withStyles(styles)<IChatMessagesProps>(
    connect(mapStateToProps, mapDispatchToProps)(ChatMessage)
);



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/components/ChatMessage.tsx